import React from 'react'
import { useMediaContext } from 'context/MediaContext'

import { Box, Button, TextField } from '@mui/material'
import { Send } from '@mui/icons-material'
import 'style/Chat.css';

import { Chat as ChatModel } from 'model/Chat'
import * as chatRepository from 'repository/ChatRepository'

import { User } from 'model/User'

type Props = {
  user: User
  chat: ChatModel
}
export default function Chat(props: Props) {
  const { isPc } = useMediaContext()

  const [msg, setMsg] = React.useState('');

  const scrollBottomRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
      scrollBottomRef?.current?.scrollIntoView();
  })

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!msg) {
      return;
    }
    chatRepository.saveMessage(props.chat, {
      user_uuid: props.user.uuid,
      user_name: props.user.name,
      message: msg,
      time: new Date().getTime()
    })
    setMsg('')
  }

  return (
    <Box sx={{
      bgcolor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      p: 3,
      border: '1px solid rgba(255, 255, 255, 0.12)',
      borderRadius: isPc ? 1 : 0
    }}>
      <Box sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}>
        {props.chat.messages.map((item, i) => (
          <div className={props.user.uuid===item.user_uuid? 'balloon_r': 'balloon_l'} key={i}>
            {props.user.uuid===item.user_uuid? getStrTime(item.time): '' }
            <div className="faceicon">
            </div>
            <div style={{marginLeft: '3px'}}>
              <p className="says">{item.message}</p>
            </div>
            {props.user.uuid===item.user_uuid? '': getStrTime(item.time)}
          </div>
        ))}
        <div ref={scrollBottomRef} />
      </Box>

      <Box
        component='form'
        onSubmit={handleSubmit}
        sx={{
          mt: 1,
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }}
      >
        <TextField
          id='msg'
          name='msg'
          size='small'
          fullWidth
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
        />
        <Button type='submit' variant='contained' size='small' sx={{
            borderTopLeftRadius: '0px',
            borderBottomLeftRadius: '0px',
          }}
        >
          <Send fontSize='small' />
        </Button>
      </Box>
    </Box>
  )
}

function getStrTime(time: number) {
  let t = new Date(time);
  return `${t.getHours()}`.padStart(2, '0') + ':' + `${t.getMinutes()}`.padStart(2, '0');
}
